import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { ListRolesComponent } from './list-role/list-role.component';
import { RoleModalAjoutFormComponent } from './modal/role-modal-ajout-form/role-modal-ajout-form.component';
import { RoleFormComponent } from './role-form/role-form.component';
import { DetailRoleComponent } from './detail-role/detail-role.component';

@NgModule({
	declarations: [
		DetailRoleComponent,
		RoleFormComponent,
		ListRolesComponent,
		RoleModalAjoutFormComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class RolesModule {}
